/* Map the orientation direction */
export enum ORIENTATION_MAP {
    col = 'base-layout--col',
    row = 'base-layout--row',
}
